
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses",
      function () {
        return require("private-next-pages/courses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses"])
      });
    }
  